
<template>
  <div class="layout">
        <!-- header -->
		<div style="margin-bottom: 15px;">
			<div v-if="projectLogo" style="float: left;">
				<img width="100px" height="80px;" :src="projectLogo">
			</div>
			<div style="margin-left: 30px;">
				<span style="display: block;">{{project_detail.address}}</span>
				<span style="display: block;">E: {{project_detail.email}}</span>
				<span style="display: block;">W: {{project_detail.website}}</span>
				<span style="display: block;">Republic Plaza Serviced Apartment</span>
			</div>
        </div>
      <div style="background-color: #2196F3; border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black" class="bg-title">
        <h3 style="margin: 0; color: #fff;text-align: center; padding: 5px 0px 5px 0px;">XÁC NHẬN ĐẶT PHÒNG</h3>
      </div>
      <div style="border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black" class="bg-title eng-text">
        <h3 style="margin: 0; color: #000;text-align: center; padding: 5px 0px 5px 0px;">RESERVATION CONFIRMATION</h3>
      </div>
      <div style="border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black; text-align: right;" class="bg-title">
        <span style="margin: 0; color: #000;text-align: right; padding: 5px 5px 5px 0px;">Ngày/date {{dayCreated}} tháng/month {{monthCreated}} năm/year {{yearCreated}}
        </span>
      </div>
      <div style="border-top: 1px solid black; border-left: 1px solid black; border-right: 1px solid black;padding-left: 4px;">
        <span style="display: block;">Cảm ơn Quý khách đã chọn sử dụng dịch vụ tại Republic Plaza Serviced Apartment</span>
        <span style="display: block;" class="eng-text">Thank you for your reservation at Republic Plaza</span>
        <span style="display: block;">Chúng tôi xin xác nhận đặt phòng theo yêu cầu của Quý khách như sau:</span>
        <span style="display: block;" class="eng-text">We are pleased to confirm your reservation as follows</span>
      </div>
      <table style="width:100%;">
        <!-- Mã đặt phòng -->
        <tr>
        <th>
            <span>Mã đặt phòng:</span><br>
            <span class="eng-text">Confirmation No</span>
        </th>
        <td colspan="7">{{apartment_booking_detail.booking_code}}</td>
        </tr>
        <!-- Tên khách hàng -->
        <tr>
        <th>
            <span>Tên khách hàng:</span><br>
            <span class="eng-text">Guest Name</span>
        </th>
        <td colspan="7">{{apartment_booking_detail.booking_person_name}}</td>
        </tr>
        <!-- Điện thoại và Email -->
        <tr>
        <th colspan="1">
            <span style="display: block">Điện thoại:</span>
            <span class="eng-text" style="display: block">Phone No.</span>
        </th>
        <th colspan="3">{{apartment_booking_detail.booking_person_phone}}</th>
        <th colspan="1">Email:</th>
        <th colspan="3">{{apartment_booking_detail.booking_person_email}}</th>
        </tr>
        <!-- Số lượng khách -->
        <tr>
        <th colspan="1">
            <span>Số lượng khách <span class="eng-text">/ Number of Pax</span></span>
        </th>
        <th colspan="3">
            <div v-for="(roomPolicy, index) in roomPolicies" :key="index" :style="index != 0 ? 'margin-top: 5px;' : null">
                <span style="display: block;">Người lớn: <span style="font-weight: normal;">{{roomPolicy.max_adults}} người / phòng ({{roomPolicy.bedroom_count}} PN)</span></span>
                <span class="eng-text" style="display: block;">Adult: <span style="font-weight: normal;">{{roomPolicy.max_adults}} person / room</span> ({{roomPolicy.bedroom_count}} {{roomPolicy.bedroom_count == 1 ? 'Bedroom' : 'Bedrooms'}})</span>
            </div>
        </th>
        <th colspan="1">
            <span style="display: block;">Trẻ em (tuổi):</span>
            <span class="eng-text" style="display: block;">Kid (age)</span>
        </th>
        <th colspan="3" style="font-weight: normal;">
            <div v-for="(roomPolicy, index) in roomPolicies" :key="index" :style="index != 0 ? 'margin-top: 5px;' : null">
                <span style="display: block;">{{roomPolicy.max_childs}} bé / phòng (dưới 6 tuổi) ({{roomPolicy.bedroom_count}} PN)</span>
                <span style="eng-text">{{roomPolicy.max_childs}} kids (under 6 yrs) ({{roomPolicy.bedroom_count}} {{roomPolicy.bedroom_count == 1 ? 'Bedroom' : 'Bedrooms'}})</span>
            </div>
        </th>
        </tr>
        <!-- Giá phòng -->
        <tr>
        <th :rowspan="apartment_usage_list.length + 4">
            <span style="display: block;">Giá phòng:</span>
            <span class="eng-text">Room rate</span>
        </th>
        </tr>
        <tr>
            <td>
                <span style="display: block;font-weight: bold;">Loại phòng / <span class="eng-text">Room Type</span></span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Từ ngày / <span class="eng-text">From</span></span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Đến ngày / <span class="eng-text">To</span></span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Đơn giá / đêm</span>
                <span class="eng-text">Unit Price / Night</span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Số đêm / <span class="eng-text">Night</span></span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Số lượng phòng / <span class="eng-text">Quantity</span></span>
            </td>
            <td>
                <span style="display: block;font-weight: bold;">Thành tiền</span>
                <span class="eng-text">Total Amount</span>
            </td>
        </tr>
        <tr v-for="(apartment_usage, index) in apartment_usage_list" :key="index">
            <td>{{apartment_usage.bedroom_count}} phòng ngủ</td>
            <td>{{checkin_datetime}}</td>
            <td>{{checkout_datetime}}</td>
            <td style="text-align: right">{{formatNumber(apartment_usage.unit_price)}}</td>
            <td style="text-align: center">{{number_of_days}}</td>
            <td style="text-align: center">{{apartment_usage.number_of_apartment}}</td>
            <td style="text-align: right">{{formatNumber(apartment_usage.total_price * apartment_usage.number_of_apartment)}}</td>
        </tr>
        <tr>
            <td style="text-align: right;" colspan="6">Tổng cộng (đã bao gồm thuế và phí nếu có) / <span class="eng-text">Total amount (including Tax and Fee if any)</span></td>
            <td style="text-align: right" colspan="1">{{formatNumber(total_amount_with_discount_with_other_fee)}}</td>
        </tr>
        <tr>
            <td style="text-align: left;" colspan="7">
                <span style="display: block;">Đơn vị tính / <span class="eng-text">Currency denomination: VND</span></span>
                <span>Bằng chữ / <span class="eng-text">In Words</span>: </span><span class="eng-text">{{readMoney(total_amount_with_discount_with_other_fee, "vi")}}. / </span><span class="eng-text">{{readMoney(total_amount_with_discount_with_other_fee, "en")}}.</span>
            </td>
        </tr>
        <tr>
            <th :rowspan="e_w_included ? 7 : 6">
                <span style="display: block;">Giá bao gồm</span>
                <span class="eng-text">Price includes</span>
            </th>
        </tr>
        <tr>
        <td colspan="7">
            <span style="display: block;">Dọn phòng 3 lần / tuần</span>
            <span class="eng-text">Cleaning room three times a week</span>
        </td>
        </tr>
        <tr>
        <td colspan="7">
            <span style="display: block;">Thay chăn drap 1 lần / tuần	</span>
            <span class="eng-text">Change drap one time a week</span>
        </td>
        </tr>
        <tr>
        <td colspan="7">
            <span style="display: block;">Internet tốc độ cao trong phòng và các khu vực công cộng</span>
            <span class="eng-text">Complimentary wifi, internet in room and public areas</span>
        </td>
        </tr>
        <tr>
        <td colspan="7">
            <span>Tiện ích Tivi thông minh tại phòng / <span class="eng-text">Smart TV</span></span>
        </td>
        </tr>
        <tr>
        <td colspan="7">
            <span>Sử dụng hồ bơi, trung tâm thể dục thẩm mỹ / <span class="eng-text">Free Pool, Gym, Billiard</span></span>
        </td>
        </tr>
        <tr v-if="e_w_included">
        <td colspan="7">
            Chi phí điện nước
        </td>
        </tr>
        <!-- Giá chưa bao gồm -->
        <tr>
        <th :rowspan="getRowSpan()">
            <span style="display: block;">Giá chưa bao gồm</span>
            <span class="eng-text">Price excludes</span>
        </th>
        </tr>
        <tr v-if="service_other_detail != null && service_other_detail != ''">
        <td colspan="7">{{service_other_detail}}</td>
        </tr>
        <tr v-if="!e_w_included">
            <td colspan="7">
                <span style="display: block;">Chi phí điện nước – Tính theo thực tế sử dụng</span>
                <span class="eng-text">Electricity and water costs- Base on actual using number</span>
            </td>
        </tr>
        <tr>
            <td colspan="7">
                <span style="display: block;">Dịch vụ ăn sáng, đưa đón sân bay, dịch vụ khác…</span>
                <span class="eng-text">Breakfast, airport pick- up, other services ...</span>
            </td>
        </tr>
        <!-- Thanh toán -->
        <tr>
        <th rowspan="5">
            <span style="display:block;">Thanh toán</span>
            <span class="eng-text">Payment</span>
        </th>
        </tr>
        <tr>
        <td colspan="7">
            (1) Đặt cọc giữ chỗ số tiền: {{amount_reservation}} VNĐ (số tiền đặt cọc giữ chỗ sẽ được hoàn trả trong vòng 5 ngày làm việc sau khi cấn trừ các chi phí phát sinh nếu có) <br>
            (2) Số tiền cần thanh toán trước: {{payment_inadvance_request}} VNĐ <br>
            (1) + (2) => <span style='font-weight:bold;'>Tổng số tiền khách cần thanh toán: {{total_amount_with_reservation}} VNĐ. Thanh toán trước ngày {{due_date}}</span><br>
            (Bằng chữ: {{readMoney(formatInteger(total_amount_with_reservation), "vi")}}./.)
            <br><br>
            <div style="font-style: italic;">
                (1) Deposit amount: VND {{amount_reservation}} (deposit will be refunded within 5 working days after deducting arise expenses (if any))<br>
                (2) Room advance payment: VND {{payment_inadvance_request}}<br>
                (1) + (2) => <span style='font-weight:bold;'>The total amount payable is VND {{total_amount_with_reservation}}. Payment must be paid before {{due_date}}</span><br>
                (In Words: {{readMoney(formatInteger(total_amount_with_reservation), "en")}}./.)
            </div>
            <!-- (1) Tiền đặt cọc giữ chỗ: {{amount_reservation}}VNĐ (số tiền đặt cọc giữ chỗ sẽ được hoàn trả trong vòng 5 ngày làm việc sau khi cấn trừ các chi phí phát sinh nếu có) <br>
            (2) Tổng tiền phòng: {{total_amount_with_discount_with_other_fee}} VNĐ. Thanh toán trước ngày {{due_date}} <br>
            <span style="font-weight: bold;">(1)+(2) => Tổng số tiền khách cần thanh toán: {{total_amount_with_reservation}} VNĐ</span> -->
        </td>
        </tr>
        <tr>
        <td colspan="7">
            <span style="display: block;">Các chi phí phát sinh khác (nếu có):  thanh toán tại quầy Lễ tân</span>
            <span class="eng-text">Payment of expenses incurred at the reception desk</span>
        </td>
        </tr>
        <tr>
            <td colspan="7">
                <span style="display: block;">Trường hợp Quý khách cần xuất hóa đơn, vui lòng thông báo với Bộ phận Đặt phòng bằng email hoặc thông báo với Lễ tân trước khi trả phòng</span>
                <span class="eng-text">In case you of issuing invoice, please notify the Reservation Department by email or inform the Reception before check out</span>
            </td>
        </tr>
        <tr>
        <td colspan="7">
            <div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Đơn vị thụ hưởng / <span class="eng-text">Beneficiary</span></span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_account_name}}</span>
                    </div>
                </div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Tài khoản / <span class="eng-text">Account No.</span> </span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_account_no}}</span>
                    </div>
                </div>
                <div>
                    <div style="width: 25%; display: inline-block;">
                        <span>Ngân hàng / <span class="eng-text">Bank</span> </span>
                    </div>
                    <div style="display: inline-block;">
                        <span>{{banktransfer.bank_code && banktransfer.bank_code.bank_code}} - {{banktransfer.bank_other_details}}</span>
                    </div>
                </div>
            </div>
        </td>
        </tr>
        <!-- Chính sách hủy -->
        <tr>
        <th>
            <span style="display:block;">Chính sách hủy</span>
            <span class="eng-text">Cancelation policy</span>
        </th>
        <td colspan="7">
            <span style="display: block;">Giá khuyến mãi trên không áp dụng cho việc hủy phòng và hoàn tiền</span>
            <span class="eng-text">The promotion price does not apply for cancellation and refund</span>
        </td>
        </tr>
        <!-- Thời gian nhận phòng và trả phòng -->
        <tr>
        <th>
            <span style="display: block;">Thời gian nhận phòng và trả phòng</span>
            <span class="eng-text">C/I & C/O time</span>
        </th>
        <td colspan="7">
            <span style="display: block;">Thời gian nhận phòng: 02:00PM và thời gian trả phòng 12:00PM.</span>
            <span class="eng-text">Check in time: 02:00PM; Check out time: 12:00PM</span>
        </td>
        </tr>
        <!-- Quy định chung -->
        <tr>
            <th rowspan="3">
                <span style="display: block;">Quy định chung</span>
                <span class="eng-text">Rules</span>
            </th>
        </tr>
        <tr>
            <td colspan="7">
                <span style="display: block;">Trường hợp quý khách muốn đặt bữa sáng mang theo, vui lòng thông báo với Lễ tân trước 21:00 tối ngày hôm trước.</span>
                <span class="eng-text">In case of order breakfast, please inform the Reception before 1 day at 09:00PM</span>
            </td>
        </tr>
        <tr>
        <td colspan="7">
            <span style="display: block;">Vật nuôi sẽ không được phép mang vào Tòa nhà</span>
            <span class="eng-text">Pets are not allowed in the Building</span>
        </td>
        </tr>
        <!-- Notes -->
        <tr>
            <th rowspan="2">
                <span style="display: block;">Ghi chú</span>
                <span class="eng-text">Notes</span>
            </th>
        </tr>
        <tr>
            <td colspan="7">
                <span style="display: block;"><br><br></span>
            </td>
        </tr>
      </table>
        <!-- Support hotline -->
        <div style="margin-top: 15px;">
            <span style="display:block;">Nếu Quý khách cần bất kỳ sự hỗ trợ hoặc thông tin bổ sung nào, xin vui lòng liên hệ với bộ phận Đặt phòng qua email: booking@republicplaza.vn.
            </span>
            <span class="eng-text">Should you require any assistance or additional information, please contact the Reservation Department via email: booking@republicplaza.vn. Very pleased to welcome you to the Republic Plaza Serviced Apartment.
            </span>
            <span style="display:block;margin-top: 5px;">Rất hân hạnh được chào đón Quý khách đến với Republic Plaza Serviced Apartment.</span>
            <span class="eng-text">We look forward to welcoming your guest to Republic Plaza</span>
        </div>
        <div style="margin-top: 15px;">
			<span style="display:block;">Trân trọng cảm ơn</span>
            <span class="eng-text">Yours sincerely</span>
		</div>
        <div class="row bg-button">
            <form class="form-horizontal">
                <div>
                    <button
                        id="cmdPrintPdf"
                        type="button"
                        class="btn btn-labeled btn-warning pull-right"
                        @click="printPdf"
                        style="margin-right: 5px;"
                    >
                        <span class="btn-label">
                            <i class="glyphicon glyphicon-print"></i>
                        </span>
                        {{$t('common.printPdf')}}
                    </button>
                </div>
            </form>
        </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment'
import utils from '@/lib/utils'
export default {
  name: "ConfirmedApartmentBookingGroupPdf",
  data() {
    return {
        projectLogo: null,
        booking_data: [],
        apartment_booking_detail: [],
        project_detail: [],
        checkin_datetime: '',
        checkout_datetime: '',
        banktransfer: '',
        number_of_days: 0,
        apartment: {
            id: 0,
            apartment_code: "",
            size: "",
            bathroom_count: 0,
            bedroom_count: 0,
            room_count: 0,
            electric_value: 0,
            water_value: 0
        },
        amount: 0,
        amount_with_discount: 0,
        total_amount_with_discount: 0,
        total_amount_with_discount_with_other_fee: 0,
        e_w_included: false,
        service_other_detail: "",
        total_amount_with_reservation: 0,
        amount_reservation: 0,
        due_date: '',
        vat: 0,
        max_adults: 0,
        max_childs: 0,
        payment_inadvance_request: 0,
        apartment_usage_list: [],
        roomPolicies: [],
        dayCreated: null,
        monthCreated: null,
        yearCreated: null
    };
  },

  watch: {
  },
  computed: {
    ...mapGetters([
    ])
  },

  methods: {
    ...mapActions([
        "GET_GROUP_BOOKING_DETAIL",
        "GET_ROOM_POLICY_WITH_BED_ROOM"
    ]),
    readMoney: function(number, locale){
        return utils.readMoney(number, locale)
    },
    formatNumber: function(price) {
        return utils.formatNumber(Number(price))
    },
    formatInteger: function(strPrice) {
        return utils.formatInteger(strPrice.toString())
    },
    getRowSpan() {
        if (!this.e_w_included && this.service_other_detail != '' && this.service_other_detail != null) {
            return 4
        } else if (!this.e_w_included && (this.service_other_detail == '' || this.service_other_detail == null)) {
            return 3
        } else if (this.e_w_included && (this.service_other_detail != '' && this.service_other_detail != null)) {
            return 3
        } else {
            return 2
        }
    },
    printPdf: function () {
        document.getElementById("cmdPrintPdf").style.display = "none";
        window.print();
        document.getElementById("cmdPrintPdf").style.display = "";
    }
  },
  mounted() {
    let booking_id = parseInt(this.$route.params.id)
    this.projectLogo = sessionStorage.getItem('projectLogo')
    if (booking_id != 0) {
        this.GET_GROUP_BOOKING_DETAIL({id: booking_id}).then(
            function(res){
                this.booking_data = res.data
                // Apartment booking detail
                this.apartment_booking_detail = this.booking_data.apartment_booking_group_detail
                this.dayCreated = utils.formatSqlDate(this.apartment_booking_detail.date_created, null, 'DD')
                this.monthCreated = utils.formatSqlDate(this.apartment_booking_detail.date_created, null, 'MM')
                this.yearCreated = utils.formatSqlDate(this.apartment_booking_detail.date_created, null, 'YYYY')
                // Deposit request
                this.amount_reservation = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_booking_detail.deposit_request.toString())))
                // Payment inadvance request
                this.payment_inadvance_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_booking_detail.payment_inadvance_request.toString())))
                // Total deposit request and payment inadvance request
                this.total_amount_with_reservation = utils.formatNumber(Number(utils.formatInteger(this.payment_inadvance_request.toString())) + Number(utils.formatInteger(this.amount_reservation.toString())))
                // Project detail
                this.project_detail = this.booking_data.project_detail
                // Project banktransfer
                this.banktransfer = this.project_detail.banktransfer
                // Check-in date time
                this.checkin_datetime = utils.formatSqlDate(this.apartment_booking_detail.checkin_datetime, null, 'DD/MM/YYYY')
                // Check-out date time
                this.checkout_datetime = utils.formatSqlDate(this.apartment_booking_detail.checkout_datetime, null, 'DD/MM/YYYY')
                // Change format to count number of days
                let checkin = utils.formatSqlDate(this.checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
                let checkout = utils.formatSqlDate(this.checkout_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
                // Number of days
                this.number_of_days = utils.datediff(checkin, checkout) == 'NaN' ? 0 : utils.datediff(checkin, checkout)
                // Calculator amount
                let apartmentInGroupBooking = this.apartment_booking_detail.apartment_in_group_booking_ids
                this.apartment_usage_list = []
                let bedrooms = []
                for (let i = 0, size = apartmentInGroupBooking.length; i < size; i++) {
                    let vat = apartmentInGroupBooking[i].pkg_template_details.package_elements[0].service_details.vat
                    let booking_room_rate_with_number_of_days = apartmentInGroupBooking[i].booking_room_rate_daily * this.number_of_days
                    let object = {
                        bedroom_count: apartmentInGroupBooking[i].apartment_details.bedroom_count,
                        unit_price: apartmentInGroupBooking[i].booking_room_rate_daily,
                        total_price: booking_room_rate_with_number_of_days,
                        total_price_after_vat: booking_room_rate_with_number_of_days + Math.round((booking_room_rate_with_number_of_days) * vat / 100)
                    }
                    if (this.apartment_usage_list.length == 0) {
                        object.number_of_apartment = 1
                        this.apartment_usage_list.push(object)
                    } else {
                        let isExist = true
                        for (let j = 0; j < this.apartment_usage_list.length; j++) {
                            if (this.apartment_usage_list[j].bedroom_count == object.bedroom_count && this.apartment_usage_list[j].unit_price == object.unit_price) {
                                isExist = true
                                this.apartment_usage_list[j].number_of_apartment += 1
                                break;
                            } else if (this.apartment_usage_list[j].bedroom_count != object.bedroom_count || this.apartment_usage_list[j].unit_price != object.unit_price) {
                                object.number_of_apartment = 1
                                isExist = false
                            }
                        }
                        if (!isExist) {
                            this.apartment_usage_list.push(object)
                        }
                    }
                    if (bedrooms.indexOf(apartmentInGroupBooking[i].apartment_details.bedroom_count) == -1) {
                        bedrooms.push(apartmentInGroupBooking[i].apartment_details.bedroom_count)
                    }
                }
                for (let k = 0; k < this.apartment_usage_list.length; k++) {
                    this.total_amount_with_discount_with_other_fee += (this.apartment_usage_list[k].total_price_after_vat * this.apartment_usage_list[k].number_of_apartment)
                }
                // Due date
                this.due_date = moment(this.apartment_booking_detail.deposit_deadline)
                this.due_date = utils.formatSqlDate(this.due_date, null, "DD/MM/YYYY")
                // this.e_w_included = this.apartment_booking_detail.ew_included
                // Service other detail
                // this.service_other_detail = this.apartment_booking_detail.apartment_mapping_with_booking_ids[0].other_details
                let data = {
                    params: {
                        bedrooms: bedrooms
                    }
                }
                this.GET_ROOM_POLICY_WITH_BED_ROOM(data).then(
                    function(res) {
                        let data = res
                        this.roomPolicies = data
                        // this.max_adults = data.max_adults
                        // this.max_childs = data.max_childs
                    }.bind(this)
                )
            }.bind(this)
        )
    }
  },
  components: {
  }
};
</script>

<style scoped>
    @media print {
        .pagebreak { page-break-before: always; } /* page-break-after works, as well */
        .layout {
            width: 90% !important;
        }
        .bg-title {
            background-color: #2196F3 !important;
            color: white !important;
            -webkit-print-color-adjust: exact;
        }
        .bg-title h3 {
            color: white !important;
            -webkit-print-color-adjust: exact;
        }
        .bg-button {
            display: none;
        }
        .padding {
            margin-top: 40px;
        }
    }
    .eng-text {
        font-style: italic;
        font-weight: normal;
    }
    .layout {
        width: 70%;
        margin: auto;
        margin-top: 40px;
        margin-bottom: 40px;
    }
    body {
        font-family: 'Times New Roman'
    }
    table, th, td {
        border: 1px solid black;
        border-collapse: collapse;
    }
    th, td {
        padding: 5px;
        text-align: left;    
    }
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ConfirmedApartmentBookingGroupPdf.vue